export const formatNumber = ( number : number ) => {
	return number.toLocaleString("cs-CZ");
};